import React from "react";
import styled from "styled-components";

import { Container } from "@util/standard";
import {
  SanityHtml,
} from "@graphql-types";

interface Props {
  content: SanityHtml;
}

const HtmlContainer = styled(Container)`
  width: 65%;
  margin: auto;
`;

const Html = ({ content }: Props) => {
  return (
    <HtmlContainer dangerouslySetInnerHTML={{ __html: content.content }} />
  );
};

export default Html;